import React, { PropsWithChildren } from 'react';
import { layoutFooterRightWrapperStyle } from './layout-footer-right.styles.css';

export const LayoutFooterRight: React.FC<PropsWithChildren<unknown>> = ({
    children
}) => <div className={layoutFooterRightWrapperStyle}>{children}</div>;
